module.exports = __webpack_public_path__ + "static/media/doclad7.6e1c90e5.pdf";